<template>
    <div class="row justify-center bg-white">
        <TitleBar v-if="$q.screen.lt.sm" center-slot="Order History" />
        <TileBar v-else class="q-mt-sm" title="Order History" />

        <q-separator />
        <div class="col-12 col-12 col-sm-10 col-md-9" style="padding: 6px 16px">
            <div class="row">
                <q-input
                    disable
                    class="col-grow"
                    dense
                    rounded
                    outlined
                    v-model="keyword"
                    placeholder="Search customer"
                    style="margin-top: 10px"
                    ><template v-slot:prepend>
                        <q-icon
                            name="person_search"
                            color="gray-10" /></template
                ></q-input>
                <q-btn
                    unelevated
                    outline
                    @click="onRefresh"
                    dense
                    class="q-mt-sm q-mx-xs"
                    size="md"
                    no-caps
                    icon="refresh"
                    label="Refresh"
                />
            </div>
            <q-list clickable>
                <OrderHistoryCard
                    v-for="(rtp, index) in list"
                    :key="index"
                    :rtp="rtp"
                />
            </q-list>
            <div class="row justify-center">
                <q-pagination v-model="current" :max="max" direction-links />
            </div>
        </div>
    </div>
</template>

<script>
import { QSeparator } from "quasar";
export default {
    name: "Customer",
    components: {
        TitleBar: () => import(`@/ui/components/TitleBar.vue`),
        TileBar: () => import(`@/ui/components/TileBar.vue`),
        OrderHistoryCard: () =>
            import(`@/ui/pages/order-history/OrderHistoryCard.vue`),
        QSeparator,
    },
    data() {
        return {
            keyword: null,
            orderHistoryList: [
                {
                    orderId: "1000210000009999",
                    branchId: "1000",
                    productList: [
                        {
                            scheduleId: 0,
                            cprcode: 53716,
                            iprcode: 53716,
                            psqty: 1,
                            pr_country_en: "",
                            online_category_l1_en: "Drinks",
                            online_category_l2_en: "Water & Mineral Water",
                            online_category_l3_en: "Still Water",
                            hema_brand_en: "Nestle",
                            hema_sizedesc: "600ml",
                            hema_name_en: "Drinking Water",
                            hema_name_th: "Drinking Water",
                            pr_use_original_img: false,
                            avail_store: {
                                1000: {
                                    visibility: true,
                                },
                                1003: {
                                    visibility: true,
                                },
                                1015: {
                                    visibility: true,
                                },
                                1016: {
                                    visibility: true,
                                },
                                1021: {
                                    visibility: true,
                                },
                                1022: {
                                    visibility: true,
                                },
                                1023: {
                                    visibility: true,
                                },
                                1026: {
                                    visibility: true,
                                },
                                1032: {
                                    visibility: true,
                                },
                                1040: {
                                    visibility: true,
                                },
                                1041: {
                                    visibility: true,
                                },
                                1047: {
                                    visibility: true,
                                },
                                1048: {
                                    visibility: true,
                                },
                                1049: {
                                    visibility: true,
                                },
                            },
                            stock: 633,
                            price: 6,
                            quantity: 1,
                            selected: true,
                            originalPrice: 5,
                            discount: 0,
                            rowTotal: 6,
                            productName: "Nestle Drinking Water 600ml",
                            remark: "",
                            settlementPrice: 6,
                        },
                    ],
                    shipping: {
                        shippingFirstName: "Test Customer",
                        shippingAddress:
                            "400 Sukhumvit Rd Vadhana Bangkok 10110",
                        shippingPhone: "+66812345678",
                        shippingEmail: "customer@gmail.com",
                        shippingType: "DELIVERY",
                    },
                    payment: {
                        subTotal: 6,
                        paymentId: "ThaiQR-1625231242.772884",
                        paymentMethod: "ThaiQR",
                        discountAmount: 0,
                        isPaid: true,
                        shippingAmount: 0,
                        grandTotal: 6,
                        totalPaid: 6,
                        status: "AUTHORIZED",
                        timestamp: 1625231456.200857,
                    },
                },
                {
                    orderId: "1000210000009999",
                    branchId: "1000",
                    productList: [
                        {
                            scheduleId: 0,
                            cprcode: 53716,
                            iprcode: 53716,
                            psqty: 1,
                            pr_country_en: "",
                            online_category_l1_en: "Drinks",
                            online_category_l2_en: "Water & Mineral Water",
                            online_category_l3_en: "Still Water",
                            hema_brand_en: "Nestle",
                            hema_sizedesc: "600ml",
                            hema_name_en: "Drinking Water",
                            hema_name_th: "Drinking Water",
                            pr_use_original_img: false,
                            avail_store: {
                                1000: {
                                    visibility: true,
                                },
                                1003: {
                                    visibility: true,
                                },
                                1015: {
                                    visibility: true,
                                },
                                1016: {
                                    visibility: true,
                                },
                                1021: {
                                    visibility: true,
                                },
                                1022: {
                                    visibility: true,
                                },
                                1023: {
                                    visibility: true,
                                },
                                1026: {
                                    visibility: true,
                                },
                                1032: {
                                    visibility: true,
                                },
                                1040: {
                                    visibility: true,
                                },
                                1041: {
                                    visibility: true,
                                },
                                1047: {
                                    visibility: true,
                                },
                                1048: {
                                    visibility: true,
                                },
                                1049: {
                                    visibility: true,
                                },
                            },
                            stock: 633,
                            price: 6,
                            quantity: 1,
                            selected: true,
                            originalPrice: 5,
                            discount: 0,
                            rowTotal: 6,
                            productName: "Nestle Drinking Water 600ml",
                            remark: "",
                            settlementPrice: 6,
                        },
                    ],
                    shipping: {
                        shippingFirstName: "Test Customer",
                        shippingAddress:
                            "400 Sukhumvit Rd Vadhana Bangkok 10110",
                        shippingPhone: "+66812345678",
                        shippingEmail: "customer@gmail.com",
                        shippingType: "DELIVERY",
                    },
                    payment: {
                        subTotal: 6,
                        paymentId: "ThaiQR-1625231242.772884",
                        paymentMethod: "ThaiQR",
                        discountAmount: 0,
                        isPaid: false,
                        shippingAmount: 0,
                        grandTotal: 6,
                        totalPaid: 6,
                        status: "AUTHORIZED",
                        timestamp: 1625231456.200857,
                    },
                },
            ],
            list: [],
            current: 1,
            max: 1,
            nextToken: {},
        };
    },
    watch: {
        current: {
            handler: function (value) {
                console.log("change page", value);
                this.loadOrders();
            },
        },
    },
    mounted() {
        this.loadOrders();
    },
    methods: {
        async loadOrders() {
            this.list = [];
            const saleID = this.$store.getters["sale/getId"];

            const result =
                await this.$services.requestToPay.listRequestToPayBySaleID(
                    saleID,
                    this.nextToken[this.current - 1]
                );

            console.log(result);

            this.list = result.requestToPayBySaleID.items;

            if (result.requestToPayBySaleID.nextToken) {
                if (this.nextToken[this.current] == undefined) {
                    this.max++;
                    this.nextToken[this.current] =
                        result.requestToPayBySaleID.nextToken;
                }
            }
        },
        onRefresh() {
            this.loadOrders();
        },
        onRightClick() {
            console.log("Add");
        },
        onAddCustomer() {
            console.log("Add customer");
        },
        onViewDetail(orderId) {
            console.log("view order: ", orderId);
            this.$router.push({ name: "OrderDetail", params: { id: orderId } });
        },
        onReorder() {
            console.log("Reorder");
            this.reorderDialog.show = true;
        },
        onConfirmReorder() {
            console.log("Confirm reorder");
            this.reorderDialog.show = false;
        },
        onCancel() {
            this.reorderDialog.show = false;
        },
    },
};
</script>

<style scoped></style>
